import _ from 'lodash'
import DatasetsFilterEquationForm from './datasets-filter-equation-form'

var DatasetsYesNoFilterStep2 = DatasetsFilterEquationForm.extend({

	/** @type {Dataset} */
	model: null,

	/**
	 * Step 2 for yes/no filters with operator "equals equation"
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.filter the filter we're working with
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.wizard the wizard this view is a part of
	 */
	initialize(options = {}) {
		if (_.isNil(options.title)) {
			options.title = options.wizard.step2Title()
		}
		let field = options.model.combinedFieldsById[options.filter.fieldId]
		options.dataType = field.dataType
		options.equation = _.get(options, 'filter.equations[0]')
		options.field = field

		DatasetsFilterEquationForm.prototype.initialize.call(this, options)

		this.on('done', () => {
			this.saveState()
			this.options.wizard.finish()
		})
	},

	saveState() {
		this.options.filter.equations = [this.equationEditor.getCleanEquation()]
	},

	render() {
		DatasetsFilterEquationForm.prototype.render.apply(this, arguments)
		this.options.wizard.render({
			formView: this.equationEditor._formView,
			stateSaver: this.saveState.bind(this)
		})
	}

})

export default DatasetsYesNoFilterStep2

DatasetsYesNoFilterStep2.__filename__ = 'datasets/filters/datasets-yes-no-filter-step2.js'
